import { useEffect } from 'react';

type UseGameExitOptions = {
  url: string; 
  getPayload: () => Record<string, any>;
};

export const useGameExitWatcher = ({ url, getPayload }: UseGameExitOptions) => {
  useEffect(() => {
    const sendBeacon = () => {
      const payload = getPayload();
      const data = JSON.stringify(payload);
      const blob = new Blob([data], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    };

    const handleBeforeUnload = () => {
      sendBeacon();
    };

    const handlePopState = () => {
      sendBeacon();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [url, getPayload]);
};
